import { createFileRoute } from '@tanstack/react-router';
import { GeneralSettingsPage } from '@/features/settings/general-page';

export const Route = createFileRoute('/w/$workspaceId/settings/general')({ component: GeneralSettingsPage });
